import { Controller } from 'stimulus';

// Segmented Templates|Batteries switch inside the Add-Task modal.
// Tabs carry data-panel="<name>"; panels carry data-panel="<name>" too.
export default class extends Controller {
  static targets = ['panel', 'tab'];

  switch(event) {
    const name = event.currentTarget.dataset.panel;

    this.panelTargets.forEach((panel) => {
      panel.classList.toggle('hidden', panel.dataset.panel !== name);
    });

    this.tabTargets.forEach((tab) => {
      const active = tab.dataset.panel === name;
      tab.classList.toggle('text-white', active);
      tab.classList.toggle('bg-cool-gray-400', active);
      tab.classList.toggle('text-gray-500', !active);
      tab.classList.toggle('bg-white', !active);
    });
  }
}
